import { useEffect } from 'react';

import useSystemBranding from '../hooks/useSystemBranding';

const appendVersion = (url: string, version: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${encodeURIComponent(version)}`;
};

const inferFaviconType = (url: string): string => {
  const lower = url.toLowerCase();
  if (lower.endsWith('.png')) {
    return 'image/png';
  }
  if (lower.endsWith('.svg')) {
    return 'image/svg+xml';
  }
  return 'image/x-icon';
};

const SystemBrandingSync = () => {
  const { faviconSrc, updatedAt } = useSystemBranding();

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const version = updatedAt || faviconSrc;
    const href = version ? appendVersion(faviconSrc, version) : faviconSrc;
    const type = inferFaviconType(faviconSrc);

    let link = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement | null;

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.type = type;
    link.href = href;
  }, [faviconSrc, updatedAt]);

  return null;
};

export default SystemBrandingSync;
